import { Button, ButtonColor, ButtonSize } from '@leland-dev/leland-ui-library';
import type { PortableTextTypeComponent } from '@portabletext/react';

interface Props {
  _type: 'callToAction';
  label: string;
  link: string;
}

const CallToAction: PortableTextTypeComponent<Props> = ({ value }) =>
  value ? (
    <div className="mb-12 flex w-full justify-center lg:mb-20">
      <a
        href={value.link}
        target="_blank"
        rel="noreferrer"
        id="call_to_action--view_cta"
      >
        <Button
          label={value.label}
          buttonColor={ButtonColor.PRIMARY}
          size={ButtonSize.LARGE}
        />
      </a>
    </div>
  ) : null;

export default CallToAction;
